export default "__VITE_ASSET__DrFlp1Uk__"